import "./edit.js";
import "./show.js";
import "./receive.js";
import { onViewLoad } from "~/jose_modern/on_view_load.js";
import { initCsvDownload } from "../shared/csv_download.js";

onViewLoad("purchase_orders#index", () => {
  initCsvDownload(document);
});
